import {
  PhoneOutlined,
  TelegramFilled,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Space, Spin } from "antd";
import { getProfile } from "entities/viewer";
import { formatPhone } from "features/auth";
import { useTranslation } from "react-i18next";

export const HelpContacts = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { data: profile, isLoading } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
  });

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 80,
        }}
      >
        <Spin />
      </div>
    );
  }

  if (!profile?.support?.phone) {
    return (
      <Space
        orientation="vertical"
        size="large"
        style={{ display: "flex", textAlign: "center" }}
      >
        {t("support.data_load_error")}
        <Button
          type="primary"
          size="large"
          style={{ margin: "0 auto", display: "flex" }}
          onClick={() => {
            queryClient.invalidateQueries({ queryKey: ["profile"] });
          }}
        >
          {t("support.try_again")}
        </Button>
      </Space>
    );
  }

  return (
    <Space orientation="vertical" size="large" style={{ display: "flex" }}>
      {!!profile?.support?.phone && (
        <Button
          type="primary"
          size="large"
          icon={<PhoneOutlined />}
          style={{ margin: "0 auto", display: "flex" }}
          onClick={() => {
            window.location.href = `tel:+${profile?.support?.phone}`;
          }}
        >
          {t("support.call", {
            phone: formatPhone(profile?.support?.phone || ""),
          })}
        </Button>
      )}

      {!!profile?.support?.whatsapp && (
        <Button
          type="primary"
          size="large"
          icon={<WhatsAppOutlined />}
          style={{ margin: "0 auto", display: "flex" }}
          onClick={() => {
            window.open(
              `https://wa.me/${profile?.support?.whatsapp}`,
              "_blank",
            );
          }}
        >
          {t("support.contact_support_wt")}
        </Button>
      )}

      {!!profile?.support?.telegram && (
        <Button
          type="primary"
          size="large"
          icon={<TelegramFilled />}
          style={{ margin: "0 auto", display: "flex" }}
          onClick={() => {
            window.open(`https://t.me/${profile?.support?.telegram}`, "_blank");
          }}
        >
          {t("support.contact_support_tg")}
        </Button>
      )}
    </Space>
  );
};
